/**
 * @module components/assistant/useStatusPill
 * @description 어시스턴트 블록 셀/필드의 도메인 상태값 → 색 variant SSoT.
 * SettlementStatusBadge.vue 의 variant 체계(variables.css 토큰)를 계승한다 —
 * useSettlementStatus.js 는 hex 하드코딩이라 재사용하지 않는다 (PRODUCT_UX §2.5.8).
 * 코드(R_REQUEST 등)와 한글 라벨("접수" 등) 양쪽 입력을 허용한다.
 */

/** 수리 접수 8-state (useRepairStatus.ts 라벨과 동일) */
const REPAIR = {
  R_REQUEST: { variant: 'info', label: '접수' },
  R_ASSIGNMENT: { variant: 'warning', label: '배정' },
  R_VISIT: { variant: 'purple', label: '방문예정' },
  R_REPAIR: { variant: 'primary', label: '수리중' },
  R_DELAY: { variant: 'danger', label: '지연' },
  R_REVISIT: { variant: 'purple', label: '재방문예정' },
  R_COMPLETE: { variant: 'success', label: '완료' },
  R_CONFIRM: { variant: 'success', label: '확정' }
}

/** 정산 9-state (SettlementStatusBadge.vue STATUS_CONFIG 와 동일) */
const SETTLEMENT = {
  CREATED: { variant: 'info', label: '생성' },
  CALCULATED: { variant: 'info', label: '계산완료' },
  CONFIRMED: { variant: 'warning', label: '확인완료' },
  APPROVED: { variant: 'success', label: '승인완료' },
  PAID: { variant: 'success', label: '지급완료' },
  DISPUTED: { variant: 'danger', label: '이의제기' },
  ADJUSTED: { variant: 'purple', label: '조정완료' },
  REJECTED: { variant: 'danger', label: '반려' },
  CANCELLED: { variant: 'gray', label: '취소' }
}

/** 상담 4-state (ConsultationHistory.vue 라벨과 동일) */
const CONSULTATION = {
  CONSULTATION_RECEIVED: { variant: 'info', label: '상담진행' },
  CONSULTATION_CALL_COMPLETED: { variant: 'success', label: '유선상완료' },
  MOVED_TO_REPAIR_REQUEST: { variant: 'primary', label: '수리접수완료' },
  CONSULTATION_CANCELLED: { variant: 'gray', label: '취소' }
}

const BY_CODE = { ...REPAIR, ...SETTLEMENT, ...CONSULTATION }

/** BE(ai-service) 상태별 집계 카운트 라벨 — 코드 없이 한글 라벨로만 도착해 BY_CODE 미매칭
 *  (2026-07-29: '접수(미배정)'/'방문대기'가 평문 렌더되던 결함 — csback.py 카운트 라벨 6종과 동기화) */
const COUNT_LABELS = {
  '접수(미배정)': { variant: 'info', label: '접수(미배정)' },
  방문대기: { variant: 'purple', label: '방문대기' }
}

const BY_LABEL = {
  ...Object.values(BY_CODE).reduce((m, v) => { m[v.label] = v; return m }, {}),
  ...COUNT_LABELS
}

/**
 * 상태값(코드 또는 한글 라벨)을 pill 설정으로 변환한다.
 * @param {*} value - 셀/필드 값
 * @returns {{variant:string,label:string}|null} 상태가 아니면 null(평문 렌더)
 */
export function resolveStatusPill(value) {
  if (value == null) return null
  const v = String(value).trim()
  if (!v) return null
  return BY_CODE[v] || BY_CODE[v.toUpperCase()] || BY_LABEL[v] || null
}
